import { render, staticRenderFns } from "./SysLanguageConfigurationModal.vue?vue&type=template&id=30b9d7c1&"
import script from "./SysLanguageConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./SysLanguageConfigurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports